// extracted by mini-css-extract-plugin
export var heroImageWidth = "wfirma-module--heroImageWidth--Ri8qg";
export var heroCopyWidth = "wfirma-module--heroCopyWidth--JunIz";
export var wfirmaLogoWrapper = "wfirma-module--wfirmaLogoWrapper--DJ5bd";
export var main = "wfirma-module--main--znd5v";
export var logo = "wfirma-module--logo--1vv5t";